import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.numbers-item__number');

    if (!counters.length) {
        return;
    }

    const runCounter = (counterElement) => {
        const endVal = parseFloat(counterElement.dataset.to);
        if (isNaN(endVal)) {
            console.error('Error value data-to:', counterElement);
            return;
        }

        const options = {
            duration: parseFloat(counterElement.dataset.duration) || 2.5,
            separator: counterElement.dataset.separator || ' ',
        };

        const aCounter = new CountUp(counterElement, endVal, options);
        if (!aCounter.error) {
            aCounter.start();
        } else {
            console.error(aCounter.error);
        }
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                runCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.3
    });

    counters.forEach(counter => {
        observer.observe(counter);
    });
});
